module.exports = __webpack_public_path__ + "images/standard-icon-862a461fbe908c3c42c47872ccfb1ff3.svg";